export default __webpack_public_path__ + "static/media/brand-6.e7e98092.png";